// extracted by mini-css-extract-plugin
export default {"productsBlock":"Products_productsBlock__IDcGi","title":"Products_title__UTfj1"};